export const title = '宠一隐私政策';

export const content = `
<div style="line-height: 1.1;">
<h1>隐私政策</h1>

<p><strong>更新日期：</strong>2026年5月15日<br>
<strong>生效日期：</strong>2026年5月15日</p>

<p>开发者：暮云宠阁（杭州）科技有限公司</p>
<p>联系方式：chongyi_2026@163.com</p>

<p>本隐私政策适用于宠一APP及本政策发布的网站服务。我们将按照本政策收集、使用、存储、共享和保护您的个人信息，并向您说明相关权限的使用场景。请在使用相关功能前仔细阅读本政策。我们是您个人信息的处理者。</p>

<h2>个人信息处理清单</h2>
<p>为便于您了解宠一APP实际处理个人信息的情况，现将检测规则涉及的信息类型、处理目的、处理方式、处理范围和触发时机集中说明如下。除本清单明确说明的情况外，我们不会收集或读取相应个人信息。</p>
<ul>
    <li><strong>IMEI、IMSI、设备 MAC 地址、SUPI、SUCI：</strong>不收集、不读取、不使用。我们不以这些设备唯一识别码识别用户，也不会将其上传或提供给第三方。</li>
    <li><strong>软件安装列表/可用应用信息：</strong>仅在您主动点击“分享”或“导航”后处理。处理方式是调用 Android 系统 Intent，查询能够处理当前分享或导航请求的应用；处理范围仅限系统返回的应用名称、包名和是否可用等必要信息；处理目的是展示可选的分享应用或地图应用，并完成您主动发起的分享或导航操作。我们不读取、不保存、不上传完整软件安装列表，不读取其他应用内的数据，不将该信息用于广告、推荐、用户画像或其他用途。您不使用分享或导航功能时，不会触发该查询。</li>
    <li><strong>位置信息：</strong>仅在您主动使用发布定位或附近内容功能，并授权前台定位权限后处理设备经纬度；处理方式为在前台调用系统定位能力；处理范围为当前设备的经纬度；处理目的是标记您主动发布的位置和展示附近内容。不进行后台定位。</li>
    <li><strong>联系人、通话记录、日历、短信：</strong>不收集、不读取、不使用，也不会申请通讯录、电话记录、日历或短信权限。</li>
    <li><strong>本机电话号码：</strong>不读取、不收集、不使用系统自动提供的本机电话号码。您主动填写的手机号码属于账号登录信息，仅用于短信验证码、身份验证和账号安全。</li>
    <li><strong>图片、视频、音频：</strong>仅在您主动选择图片或视频，或主动拍摄图片或视频后处理您选中的文件；处理范围为您本次选择或拍摄的图片、视频；处理方式为上传至服务端用于头像、封面、帖子或资料展示。不会读取未选择的媒体，不收集、不录制、不上传音频。</li>
</ul>
<p>上述信息处理均以实现您主动使用的功能为目的。除法律法规另有规定或您另行授权外，我们不会将上述信息用于广告、精准营销、用户画像或与当前功能无关的其他用途。</p>

<h2>信息收集</h2>
<p>个人信息包括可以允许某人识别您个人身份的信息，例如，您的姓名、电子邮件地址，以及与任何此类身份信息相关联或链接的有关您的任何其他非公开信息。匿名信息包括汇总和/或去识别化数据，这些数据与您的个人信息无关或关联，并且通常本身无法识别个人身份。我们收集个人信息和匿名信息，如下所述。</p>
<p>您可能并不总是需要向我们提供个人信息才能浏览我们的服务。但是，如果您不提供必要的个人信息，我们可能无法回复您的查询或向您提供某些服务。</p>

<h2>收集的信息类型、目的和方式</h2>
<p>我们仅在提供相应功能所必需的范围内收集信息。不同信息的收集时机、用途和处理方式如下：</p>
<ul>
    <li><strong>手机号码：</strong>当您登录或注册时由您主动填写，用于发送短信验证码、完成身份验证、创建和维护账号，以及处理账号安全问题。未提供手机号码将无法使用登录后的功能。</li>
    <li><strong>账号及资料信息：</strong>包括昵称、头像、个人主页封面、性别、城市、个性签名、兴趣、人设等您主动填写或选择的信息，用于展示个人资料、提供社区互动和个性化服务。您可以不填写非必填资料，不影响基本浏览功能。</li>
    <li><strong>宠物及商家资料：</strong>包括宠物昵称、品种、生日、体重、性别、免疫和绝育情况、性格、技能，以及商家名称、联系电话、地址、营业时间、坐标和门店图片等您主动提交的信息，用于生成宠物档案、商家主页、发布服务内容和提供导航功能。</li>
    <li><strong>图片和视频：</strong>当您主动选择“从相册选择”或“拍照/录像”时，我们仅处理您选中的媒体文件，用于头像、主页封面、帖子、评论或商家资料的上传和展示；不会在您未操作时扫描或上传相册中的其他文件。拒绝相册或相机权限仅会影响对应功能。</li>
    <li><strong>位置信息：</strong>当您主动使用发布定位或附近内容功能时，在获得系统前台定位授权后收集设备的经纬度，用于在内容中标记位置和展示附近内容。位置若随您发布的内容保存，将作为该内容的一部分展示；拒绝定位权限不影响其他功能。</li>
    <li><strong>设备和网络信息：</strong>在应用启动并完成隐私同意后，以及调用服务接口时，我们可能收集设备品牌、型号、设备名称、系统版本、屏幕宽高、设备是否为真实设备、操作系统、应用版本、渠道、时区、语言、IP地址和请求日志，用于登录安全、接口兼容、故障排查和防止恶意访问。当前版本不读取或使用IMEI、IMSI、设备MAC地址、Android ID、IDFA、SUPI、SUCI等设备唯一识别码。</li>
    <li><strong>软件安装列表及可用应用信息：</strong>当您主动点击商家“导航”或帖子、个人主页中的“分享”功能时，应用会通过Android系统Intent查询能够处理当前导航或分享请求的应用是否可用，以及系统返回的应用名称、包名等必要信息，用于展示可选择的地图/分享应用并启动您选择的功能。该查询由系统在您点击功能后触发，不读取应用内的账号、联系人或其他应用数据；我们不会收集或上传完整的软件安装列表，不用于广告或用户画像。拒绝或无法获取该信息时，其他功能不受影响。</li>
    <li><strong>日志信息：</strong>应用会在本地生成必要的运行日志用于故障排查。只有当您在“关于我们”页面主动确认上传日志后，我们才会将日志压缩包上传给我们；日志可能包含操作时间、错误信息、请求状态和设备基础信息，不包含您相册中未选择的文件。您不上传日志不影响正常使用。</li>
    <li><strong>您主动提交的其他信息：</strong>包括评论、举报、屏蔽关系、客服邮件及您在使用服务时主动填写的内容，仅用于提供相应功能、内容审核、处理反馈和保障社区安全。</li>
</ul>

<h2>信息来源</h2>
<p>我们主要通过以下方式获得信息：</p>
<ul>
    <li><strong>您主动提供：</strong>注册登录、编辑资料、创建宠物档案、商家入驻、发布内容、评论、举报、屏蔽、联系客服和上传文件时提供的信息。</li>
    <li><strong>应用自动生成：</strong>调用接口时产生的设备基础信息、网络信息、操作记录和错误日志。</li>
    <li><strong>您主动授权：</strong>使用定位、相机、相册或导航功能时，系统在相应权限范围内提供的位置、媒体或地图应用可用性信息。</li>
</ul>
<p>除非法律法规另有规定或您另行授权，我们不会从无关的第三方购买、收集或推断您的个人信息。</p>

<h2>权限使用说明</h2>
<p>我们不会在首次启动时一次性申请所有权限，而是在您主动使用对应功能时申请：</p>
<ul>
    <li><strong>相机权限：</strong>用于拍摄头像、主页封面、帖子或商家资料中的图片和视频。只有您点击拍摄或录像后才会调用相机。</li>
    <li><strong>相册/媒体权限：</strong>用于读取您在选择器中主动选中的图片或视频，以便上传头像、封面、帖子或商家资料。我们不会读取或上传未选择的媒体。</li>
    <li><strong>前台定位权限：</strong>用于发布定位和附近内容功能，仅在您主动使用相关功能时请求，不进行后台持续定位。</li>
    <li><strong>网络权限：</strong>用于登录、加载内容、上传您主动选择的文件和提交用户操作。没有网络时，部分在线功能无法使用。</li>
</ul>
<p>我们不会申请或收集与当前功能无关的通讯录、联系人、通话记录、日历、短信、电话状态或本机电话号码，也不会读取或上传上述信息；我们不收集音频。上述信息不用于任何业务、广告或用户画像。</p>

<h3>第三方应用和服务</h3>
<p>当您主动使用商家导航或系统分享时，应用可能调用设备中已安装的地图应用或分享应用。系统会查询能够处理当前Intent的应用，并展示系统分享面板或地图选择面板；相关查询结果仅用于完成您主动发起的操作，不会被上传至我们的服务器。地图应用或分享应用启动后的处理由相应应用独立完成，具体以该应用公布的隐私政策为准。当前版本未集成微信登录、微信支付或其他用于读取设备唯一识别码的微信SDK。</p>

<h2>个人信息的保留</h2>
<p>我们仅在实现收集目的所必要的期限内保留您的个人信息：账号和账号资料通常保留至您注销账号；您发布的内容、评论、举报和屏蔽关系通常保留至您删除、注销账号或实现相应处理目的所需的期限；设备和网络信息、运行日志仅在安全、兼容和故障排查所需期限内保留。达到目的后，我们将删除或匿名化处理相关信息，但法律法规要求保留、为处理争议或保障交易和服务安全所必需的除外。注销账号后，备份中的信息可能需要经过合理期限才能删除。</p>

<h2>信息的使用</h2>
<p>我们将收集的信息用于各种目的，包括：</p>
<ul>
    <li>为您提供我们的服务，包括允许您录制或上传内容以在我们的服务中展示，包括在现实生活中的位置。</li>
    <li>为您提供您请求的通知。</li>
    <li>设置和维护您的帐户。</li>
    <li>保存和展示您主动填写的资料、宠物档案、商家信息及发布内容。</li>
    <li>回复您的询问、请求和问题。</li>
    <li>通知您有关我们服务的更改、有关我们服务和新功能或产品的新闻以及管理通知。</li>
    <li>允许您在选择时参与我们服务的互动功能。</li>
    <li>验证您的身份和使用服务的资格。</li>
    <li>改善我们的服务管理和您的体验。</li>
    <li>提供客户支持。</li>
    <li>处理举报、屏蔽、内容审核和社区安全事件。</li>
    <li>收集分析或有价值的信息，以便我们改进我们的服务。</li>
    <li>监控我们服务的使用情况。</li>
    <li>监控您使用我们服务的频率。</li>
    <li>调查、检测、预防和解决欺诈、滥用、技术问题、违反我们的条款、政策和协议的行为，以及其他有害或非法的活动。</li>
    <li>遵守适用法律，配合执法部门或其他机构对涉嫌违法行为的调查，和/或追究或捍卫法律威胁和/或索赔。</li>
    <li>出于我们在收集数据时可能向您描述的原因。</li>
</ul>
<p>我们可能会从个人信息中创建匿名或汇总信息，使其不再是个人信息。我们使用这些匿名信息来分析我们服务的使用情况，并改进我们的服务和其他产品。我们保留将匿名信息用于任何合法目的以及不受限制地向第三方披露匿名信息的权利，除非适用法律可能禁止。</p>

<h2>信息披露</h2>
<p>您的某些活动对我们服务的所有用户和公众都是可见的。例如，当您上传内容以在我们的服务中展示时，您的显示名称和上传的内容将被公开共享。</p>

<h2>信息传输、共享和委托处理</h2>
<ul>
    <li>为了提供登录、内容展示、图片或视频上传等服务，您主动提交的信息会通过网络传输至我们的服务端，并由我们及为我们提供服务器、对象存储、短信、网络和安全服务的服务商在必要范围内处理。</li>
    <li>我们不会出售或出租您的个人信息。除非获得您的授权、法律法规要求，或为提供您主动使用的功能所必需，我们不会向无关第三方共享您的个人信息。</li>
    <li>当您主动选择地图应用进行导航时，应用会向您选择的地图应用传递导航所需的地址、经纬度和地点名称。该地图应用独立处理相关信息，具体以其隐私政策为准。</li>
    <li>您公开发布的昵称、头像、帖子、评论、商家信息及随内容发布的位置，可能被其他用户或公众查看。您可以在发布前自行决定是否提供或公开这些信息。</li>
</ul>

<h3>屏蔽和举报功能数据处理声明</h3>
<p>为保障用户的使用体验和社区安全，平台提供屏蔽和举报功能。以下是相关数据处理方式的说明：</p>
<p><strong>屏蔽功能：</strong></p>
<ul>
    <li>当用户屏蔽其他用户时，平台将记录屏蔽关系，并在后续内容展示中过滤被屏蔽用户的内容。</li>
    <li>屏蔽操作仅对执行屏蔽的用户生效，不影响其他用户。</li>
    <li>屏蔽关系数据将存储在服务器中，用户可随时解除屏蔽。</li>
</ul>
<p><strong>举报功能：</strong></p>
<ul>
    <li>当用户举报其他用户或内容时，平台将记录举报信息，包括举报人、被举报内容或用户、举报原因和时间戳。</li>
    <li>举报信息将用于内容审核和处理，平台可能会对高频被举报内容进行自动标记，并通知人工审核团队。</li>
    <li>举报处理结果将通过系统通知或邮件反馈给举报人。</li>
</ul>
<p><strong>数据存储与保护：</strong></p>
<ul>
    <li>屏蔽和举报相关数据将严格保密，仅用于平台内部审核和处理。</li>
    <li>平台将采取合理的技术和管理措施，保障数据安全，防止未经授权的访问、使用或泄露。</li>
</ul>
<p><strong>用户权利：</strong></p>
<ul>
    <li>用户可随时查看和管理自己的屏蔽列表。</li>
    <li>用户可通过设置页面或联系客服，查询举报处理进度和结果。</li>
</ul>

<h2>账号注销条款</h2>
<p><strong>注销权利</strong></p>
<ul>
    <li>您有权随时永久终止使用本APP服务，并通过以下方式注销账号：</li>
    <li>自主注销：通过「设置-账号与安全-注销账号」入口操作</li>
    <li>人工注销：发送邮件至 chongyi_2026@163.com  提交申请（需验证身份）</li>
    <li>冷静期设置：提交申请后保留72小时撤销期（期间可登录撤回）</li>
</ul>
<p><strong>重要提示</strong></p>
<ul>
    <li>不可恢复性：注销后无法找回账号、虚拟资产及历史数据</li>
    <li>例外情形：账号存在未完结投诉/纠纷时暂缓注销</li>
</ul>

<h2>我们还可能在以下情况下共享信息</h2>
<p><strong>执法</strong><br>
在某些情况下，如果法律要求或响应公共机构（例如法院或政府机构）的有效要求，我们可能需要披露您的信息。</p>

<p><strong>法律要求</strong><br>
当我们认为有必要披露您的信息以遵守法律义务（例如法院命令、搜查令或传票）、防止或调查与服务相关的欺诈、滥用、可能的不当行为、防止身体或财务损失或避免法律责任时，我们可能会向执法部门、政府官员或其他第三方披露您的信息。</p>

<p><strong>业务转让</strong><br>
我们可能会在准备、谈判期间或在任何合并、融资、收购或解散交易或涉及出售、转让、剥离或披露我们全部或部分业务或资产的程序中共享您的部分或全部信息。我们还可能在资不抵债、破产或接管的情况下传输或共享信息。</p>

<p><strong>保护我们的权利和我们的用户</strong><br>
如果我们认为有必要回应针对我们的索赔，执行或管理我们的协议、条款和政策，预防欺诈、风险评估、调查和/或保护我们以及我们的关联公司、合作伙伴、客户、客户、用户和/或其他人的权利、财产或安全，我们可能会披露个人信息。</p>

<p><strong>其他披露</strong><br>
我们可能会根据（a）您的同意，（b）根据您的指示，（c）在收集信息时向您说明，向其他方披露信息并用于其他目的。</p>

<h2>数据安全</h2>
<p>您的数据安全对我们很重要，但请记住，没有任何互联网传输方法或电子存储方法是 100% 安全的。虽然我们努力使用行业标准方法来保护您的个人信息，但我们无法保证其绝对安全。</p>

<p>根据法律，您对自己的个人信息享有多项权利。有关您的权利的更多信息和建议，可以从您所在国家/地区的数据保护监管机构获得：</p>

<ul>
    <li>您有权获得有关我们如何使用您的个人信息以及您的权利的清晰、透明和易于理解的信息。这就是我们为您提供本政策中信息的原因。</li>
    <li>您有权访问您的信息（如果我们正在处理）和某些其他信息（类似于本政策中提供的信息）。</li>
    <li>如果您的信息不准确或不完整，您有权要求更正。</li>
    <li>您有权要求删除或移除您的信息，如果我们没有令人信服的理由继续使用您的信息。这不是一般权利，也有例外。</li>
    <li>您有权“阻止”或禁止进一步使用您的信息。当处理受到限制时，我们仍然可以存储您的信息，但可能不会进一步使用。我们会保留要求进一步使用其信息的人员名单，以确保将来遵守限制。</li>
    <li>您有权在不同服务中出于自己的目的获取和重复使用您的个人信息。</li>
    <li>您有权反对某些类型的处理，包括为直接营销而进行的处理，或者我们依赖我们的合法利益进行处理的情况。</li>
    <li>您有权就我们处理或处理您个人信息的方式向您的国家数据保护监管机构提出投诉。</li>
    <li>如果您已同意我们对您的个人信息进行任何处理，您有权随时撤回您的同意（尽管如果您这样做，并不意味着我们在此之前未经您同意对您的个人信息所做的任何事情都是非法的）。这包括您撤销同意我们将您的个人信息用于营销目的的权利。</li>
</ul>

<h2>本隐私政策的变更</h2>
<p>我们可能会不时更新我们的政策。我们将通过在此页面上发布新政策来通知您任何更改。请查看本政策顶部的“生效日期”。如果适用法律要求，我们将在任何重大变更生效之前通过电子邮件和/或我们服务上的醒目通知通知您，并更新本政策顶部的“生效日期”。建议您定期查看本政策以了解任何更改。本政策的更改在本页面上发布时生效。</p>
</div>
`;
